import { HeadingPages } from '../../../components/HeadingPages';
import Header from '../../../components/Header';
import { Box, Button, Flex, Input, useToast } from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { api } from '../../../services/api';
import { ModalVisualizaPdf } from './ModalVisualizaPdf';
import { convertBlobToBase64 } from '../../../utils/convertBlobToBase64';

export function VisualizarEtiqueta() {
  const referenceNunota = useRef(null);
  const [loading, setLoading] = useState(false);
  const [base64PdfString, setBase64PdfString] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const toast = useToast({
    position: 'top-right'
  });

  //https://api.innovationbrindes.com.br/api/site/v2/orcamento/visualiza-etiqueta-sem-nf/197057

  async function handleSearchEtiqueta(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const nunota = referenceNunota.current.value;

      if (!nunota) {
        toast({
          title: 'Erro ao buscar etiqueta',
          description: 'Digite o numero da nota',
          status: 'error',
          duration: 3000,
          isClosable: true
        });

        setLoading(false);
        return;
      }
      ///status-pedido/visualizar-etiqueta 197057

      const response = await api.get(`/site/v2/orcamento/visualiza-etiqueta-sem-nf/${nunota}`, {
        responseType: 'blob'
      });

      const base64Pdf = await convertBlobToBase64(response.data);

      setBase64PdfString(base64Pdf);

      setIsOpen(true);

      setLoading(false);
    } catch (error) {
      console.log(error);
      toast({
        title: 'Erro ao buscar etiqueta',
        description: 'Erro ao buscar etiqueta',
        status: 'error',
        duration: 3000,
        isClosable: true
      });

      setLoading(false);
      setIsOpen(false);
    }
  }

  return (
    <>
      <HeadingPages name="Visualizar Etiqueta" />

      <Box
        maxW="1200px"
        mx="auto"
        mt="10"
        p="5"
        w="100%"
        borderRadius="md"
        display="flex"
        flexDirection="column">
        <Flex
          align="center"
          justify="center"
          gap={2}
          maxW="500px"
          mx="auto"
          w="100%"
          borderRadius="md"
          as="form"
          onSubmit={handleSearchEtiqueta}>
          <Input placeholder="Digite o numero da nota" ref={referenceNunota} />
          <Button colorScheme="blue" type="submit" isLoading={loading}>
            Buscar
          </Button>
        </Flex>

        {/* <mostrar a etiqueta no html  */}

        <ModalVisualizaPdf
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          base64PdfString={base64PdfString}
        />
      </Box>
    </>
  );
}
